import { render, staticRenderFns } from "./RequestLivestreamDialog.vue?vue&type=template&id=546d66a5&scoped=true&"
import script from "./RequestLivestreamDialog.vue?vue&type=script&lang=js&"
export * from "./RequestLivestreamDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d66a5",
  null
  
)

export default component.exports